import { useState, useEffect } from 'react';
import Navigation from '../../components/base/Navigation';
import Footer from '../../components/base/Footer';

export default function About() {
  const [activeTab, setActiveTab] = useState('story');

  useEffect(() => {
    document.title = 'About Us - Evolution Home | Luxury Home Renovations';
  }, []);

  const timeline = [
    { year: '2019', title: 'Company Founded', desc: 'Evolution Home was established with a vision to transform residential spaces' },
    { year: '2019', title: 'First Major Project', desc: 'Completed our first luxury home renovation in downtown district' },
    { year: '2021', title: 'Team Expansion', desc: 'Grew our team to include specialized craftsmen and designers' },
    { year: '2022', title: '150+ Projects', desc: 'Reached milestone of 50 completed renovations' },
    { year: '2023', title: 'Commercial Division', desc: 'Expanded services to include commercial unit renovations' },
    { year: '2025', title: '350+ Projects', desc: 'Celebrated completion of over 350 premium renovation projects' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/ac43fbc370dda73f0074e9387e20055d.jpg')`
        }}
      >
        <div className="text-center text-white px-4">
          {/* Logo in About Hero */}
          <div className="mb-6">
            <img 
              src="https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/4aa7700c01a2a06640654e7632c5fa8b.png" 
              alt="Evolution Home Renovations" 
              className="h-20 w-auto object-contain mx-auto"
            />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-4">About Evolution Home</h1>
          <p className="text-xl text-gray-200">Crafting luxury spaces since 2019</p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold text-black mb-6">Our Journey</h2>
            <p className="text-lg text-gray-600 mb-6">
              Founded in 2019, Evolution Home emerged from a simple belief: every space has the potential 
              for transformation. What started as a small renovation company has evolved into a premier 
              luxury home renovation service.
            </p>
            <p className="text-lg text-gray-600 mb-8">
              With over 100 completed projects, we've built our reputation on exceptional craftsmanship, 
              innovative design, and unwavering commitment to client satisfaction.
            </p>
            
            <div className="grid grid-cols-2 gap-6 max-w-md mx-auto">
              <div className="text-center p-4 bg-white rounded-lg shadow-sm">
                <div className="text-3xl font-bold text-red-600">350+</div>
                <div className="text-gray-600">Projects Completed</div>
              </div>
              <div className="text-center p-4 bg-white rounded-lg shadow-sm">
                <div className="text-3xl font-bold text-red-600">6+</div>
                <div className="text-gray-600">Years Experience</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-black mb-4">Our Timeline</h2>
            <p className="text-xl text-gray-600">Milestones in our journey to excellence</p>
          </div>

          <div className="relative">
            <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 w-1 h-full bg-red-600"></div>
            
            {timeline.map((item, index) => (
              <div key={index} className={`relative flex items-center mb-12 ${index % 2 === 0 ? 'md:justify-start' : 'md:justify-end'}`}>
                <div className={`w-full md:w-1/2 ${index % 2 === 0 ? 'md:pr-8 md:text-right' : 'md:pl-8 md:text-left'} pl-12 md:pl-0`}>
                  <div className="bg-white p-6 rounded-lg shadow-lg border-l-4 md:border-l-0 md:border-t-4 border-red-600 hover:shadow-xl transition-all duration-300">
                    <div className="text-2xl font-bold text-red-600 mb-2">{item.year}</div>
                    <h3 className="text-xl font-semibold text-black mb-2">{item.title}</h3>
                    <p className="text-gray-600">{item.desc}</p>
                  </div>
                </div>
                <div className="absolute left-4 md:left-1/2 transform md:-translate-x-1/2 w-4 h-4 bg-red-600 rounded-full border-4 border-white"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
